module.exports = __webpack_public_path__ + "static/media/next-arrow.48716c0c.svg";